import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allProducts } from '@/mocks/data/catalogue/products'

import { api } from '@/utils/constants'

import { Product } from '@/types/catalogue/product'

export const getProduct = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.products.DETAILS}`,
    ({ params }) => {
        const { id } = params

        const productFound = allProducts.find(
            (product) => product.id.toString() === id,
        )

        // Not found
        if (!productFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<Product>(productFound)
    },
)
